import { FilterChoice } from '../../../common/components/SearchHeader/types/FilterChoice';
import { renderLocationChoice } from '../../../common/components/SearchHeader/types/LocationChoice';
import { SidebarLinkSection } from '../../ResultView/Sidebar/SidebarLinkSection/SidebarLinkSection';
import { composeFilters } from '../../page-seo/composeFilters';
import { makeLinkSpec } from '../../page-seo/makeLinkSpec';
import { LinkSection } from '../LinkSection/LinkSection';
import { makeInterestPreset } from './helpers';

interface Props {
  filters: FilterChoice;
  isSidebar?: boolean;
}

export const ConditionPresetLinks = ({ filters, isSidebar = false }: Props) => {
  const commonLinkSectionProps = {
    title: `Find practices by condition in ${renderLocationChoice(filters.location)}`,
    links: getLinksBySpecialty(filters.topic?.specialist).map(preset =>
      makeLinkSpec(composeFilters(filters, preset.filters), preset.title),
    ),
  };

  const linkSection = isSidebar ? (
    <SidebarLinkSection {...commonLinkSectionProps} />
  ) : (
    <LinkSection {...commonLinkSectionProps} />
  );

  return !filters.onlineAppointments ? linkSection : null;
};

const getLinksBySpecialty = (filterName?: string) => {
  if (filterName === 'Physiotherapist')
    return [
      makeInterestPreset('Arthritis'),
      makeInterestPreset('Back Pain'),
      makeInterestPreset('Balance Problems'),
      makeInterestPreset('Gait and Balance', 'Gait and Balance Problems'),
      makeInterestPreset('Headaches'),
      makeInterestPreset('Hip Pain'),
      makeInterestPreset('Knee Pain'),
      makeInterestPreset('Lower Back Pain'),
      makeInterestPreset('Migraine'),
      makeInterestPreset('Motor Vehicle Injuries'),
      makeInterestPreset('Whiplash'),
      makeInterestPreset('Neck Pain'),
      makeInterestPreset('Posture Correction'),
      makeInterestPreset('Shoulder Pain'),
      makeInterestPreset('Soft Tissue and Muscle Injuries'),
      makeInterestPreset('Sports Injuries'),
      makeInterestPreset('Sports Injury Prevention'),
      makeInterestPreset('Sports Physiotherapy'),
      makeInterestPreset('Work Injuries'),
    ];

  return [];
};
